import { pup, bot, asparago, nasa, royal, barber, solicitors, fitnessApp, CovidApp, register, TicTacToe, filesconverto, tlg, profitRadar } from 'img';
import { react, git, mongo, nodeJS, gcloud, bootstrap, figma, html, css, scss, js, styled, router, express, vscode, npm, tailwind, nextjs, ts, chatgpt, vercel } from 'img'

export const projects = [
    {
        alt: "Profit Radar",
        githubHref: "https://github.com/PavDevUK/profit-radar",
        src: profitRadar,
        text: "Modern Next.js application and scraping toolkit for tracking Copart auctions, exploring sale calendars, and analysing lot details with market enrichment.",
        title: "Profit Radar",
        year: "2025-present",
        webHref: { href: "https://profit-radar-ten.vercel.app/", button: "Visit" },
        stack: [react, nextjs, ts, tailwind, pup, nodeJS, chatgpt, vercel]
    },
    {
        alt: "Timeline Generator",
        githubHref: "https://github.com/PavDevUK/TLG",
        src: tlg,
        text: "Full-stack Next.js application that automatically tracks GitHub repositories and generates AI-powered daily summaries.",
        title: "Timeline Generator",
        year: "2025-present",

        webHref: { href: "https://time-line-generator.vercel.app", button: "Visit" },
        stack: [react, nextjs, ts, tailwind, nodeJS, chatgpt, vercel]
    },
    {
        alt: "FilesConverto.com",
        githubHref: "https://github.com/pavdevuk/Filesconverto",
        src: filesconverto,
        text: "Next.js + TypeScript web application for converting, compressing, and managing files in various formats. The platform features a drag-and-drop uploader.",
        title: "FilesConverto",
        year: "2025",

        webHref: { href: "https://filesconverto.vercel.app/", button: "Visit" },
        stack: [react, nextjs, ts, styled, tailwind, nodeJS, npm, vercel]
    },
    {
        alt: "TicTacToe",
        githubHref: "https://github.com/pavdevuk/Portfolio-react/tree/master/src/components/F-Projects/TicTacToe",
        src: TicTacToe,
        text: "Tic-tac-toe is a game where two players take turns placing 'O' or 'X' on a 3x3 grid. This React app features a simple interface and a game logic.",
        title: "Tic Tac Toe",
        year: "2020",

        webHref: { href: "/TicTacToe", button: "Visit" },
        stack: [react, js, figma, styled, nodeJS, npm]
    },
    {
        alt: "Covid-app",
        githubHref: "https://github.com/pavdevuk/Covid-Tracker",
        src: CovidApp,
        text: "Application providing information and data related to COVID-19. It's a React app created with Create React App and styled with styled-components.",
        title: "Covid-Data",
        year: "2020",

        webHref: { href: "/covid", button: "Visit" },
        stack: [react, js, figma, styled, gcloud, nodeJS, npm]
    },
    {
        alt: "Chat Bot",
        githubHref: "https://github.com/pavdevuk/Messenger ",
        src: bot,
        text: "Chat Bot is a simple app that lets anyone converse with an AI. It's simple and fun. Chat history and a MERN-stack backend will be added later.",
        title: "Chat Bot",
        year: "2021",

        webHref: { href: "", button: "Visit" },
        stack: [react, router, js, figma, styled, gcloud, git, npm]
    },
    {
        alt: "Fitness App",
        githubHref: "https://github.com/pavdevuk/FitnessApp",
        src: fitnessApp,
        text: "A simple fitness app to track exercise duration and date. The app is built with React/Node.js and deployed on Google Cloud. Data is stored in MongoDB Atlas.",
        title: "Fitness App",
        year: "2021",

        webHref: { href: "", button: "Visit" },
        stack: [react, bootstrap, nodeJS, express, mongo, gcloud, git]
    },
    {
        alt: "Nasa",
        githubHref: "https://github.com/pavdevuk/Nasa",
        src: nasa,
        text: "Website about space-related events and topics using the NASA API. The front page focuses on SpaceX; other pages contain space images.",
        title: "Nasa",
        year: "2020",


        webHref: { href: "https://pawdevuk.github.io/NASA/", button: "Visit" },
        stack: [js, html, css, bootstrap, git, vscode]
    },
    // {
    //     alt: "Register",
    //     githubHref: "https://github.com/pavdevuk/Portfolio-react/tree/RegisterLogin/src/components/F-Projects/Register_Login",
    //     src: register,
    //     text: "Simple app with home and login components. The app has two color schemes and is built with React, styled-components, and react-router-dom.",
    //     title: "Register/Sign in Page",
    //     webHref: { href: "/RegisterSignIn", button: "Visit" },
    //     stack: [react, scss, html, css, vscode, git]
    // },
    {
        alt: "Royal Oak Architects",
        githubHref: "https://github.com/pavdevuk/Architect",
        src: royal,
        text: "A light, mobile-first website for customers who prefer simple, clean designs. Built using Bootstrap.",
        title: "Royal Oak Architects",
        year: "2020",

        webHref: { href: "https://pawdevuk.github.io/Architect/", button: "Visit" },
        stack: [html, css, bootstrap, git, vscode]
    }, {
        alt: "Gentlemen Barber",
        githubHref: "https://github.com/pavdevuk/Barber",
        src: barber,
        text: "Simple Bootstrap barber website. It's informative and written in a friendly tone to appeal to customers of all ages.",
        title: "Gentlemen Barber",
        year: "2020",
        webHref: { href: "https://pawdevuk.github.io/Barber/", button: "Visit" },
        stack: [html, css, bootstrap, git, vscode]
    },
    {
        alt: "Goodwood Solicitors",
        githubHref: "https://github.com/pavdevuk/Solicitors",
        src: solicitors,
        text: "Mobile-first website with navigation to subpages. Features a light color scheme, parallax image, contact form, and more.",
        title: "Goodwood Solicitors",
        year: "2020",

        webHref: { href: "https://pawdevuk.github.io/Solicitors/", button: "Visit" },
        stack: [html, css, bootstrap, git, vscode]
    }, {
        alt: "Asparago",
        githubHref: "https://github.com/pavdevuk/Architect",
        src: asparago,
        text: "Bootstrap restaurant page with menu, carousel, content, location, and parallax background images. The modern design provides easy access to information.",
        title: "Asparago",
        year: "2020",
        webHref: { href: "https://pawdevuk.github.io/asparago.online/", button: "Visit" },
        stack: [html, css, bootstrap, git, vscode]
    }
]